<article class="container">
  <header class="header">
    <img
      src="../../../../../../../assets/errors/warning-sign.png"
      alt="Warning sign"
    />
    <h1 class="header__heading">{{ title }}</h1>
    <span *ngIf="messageHtml; else plainTextMessage"
          [innerHTML]="messageHtml"></span>
    <ng-template #plainTextMessage>
      <span>{{ message }}</span>
    </ng-template>
  </header>
  <footer class="footer">
    <button
      mat-flat-button
      color="primary"
      class="footer__action"
      (click)="onClickClose()"
    >
      Close
    </button>
  </footer>
</article>
